import { useEffect, useState } from "react";
import axios from "../../api";
import { Link } from "react-router-dom";
import { FaHeart } from "react-icons/fa";

export default function WishlistPage() {
  const token = localStorage.getItem("access_token");
  const [wishlist, setWishlist] = useState([]);

  // Load wishlist
  const loadWishlist = () => {
    axios
      .get("/api/wishlist/", {
        headers: { Authorization: `Bearer ${token}` },
      })
      .then((res) => setWishlist(res.data))
      .catch((err) => console.log(err));
  };

  useEffect(() => {
    loadWishlist();
  }, []);

  // Remove from Wishlist
  const removeWishlist = async (productId) => {
    await axios.post(
      "/api/wishlist/toggle/",
      { product_id: productId },
      {
        headers: { Authorization: `Bearer ${token}` },
      }
    );

    // Remove instantly from UI
    setWishlist((prev) => prev.filter((item) => item.product.id !== productId));
  };

  return (
  <div className="max-w-[1200px] mx-auto px-1 py-6">


      <h2 className="text-2xl font-bold mb-6">❤️ My Wishlist</h2>


      {/* Empty State */}
      {wishlist.length === 0 && (
        <div className="text-center py-20 text-gray-600">
          <FaHeart className="mx-auto text-5xl text-red-400 mb-4" />
          <p className="text-lg">Your wishlist is empty</p>
          <Link
            to="/all-products"
            className="mt-4 inline-block bg-indigo-600 text-white px-4 py-2 rounded-lg"
          >
            Browse Products
          </Link>
        </div>
      )}

      {/* Wishlist Grid */}
{/* Wishlist LIST UI like Flipkart */}
<div className="space-y-4">
  {wishlist.map((item) => (
    <div
      key={item.id}
      className="bg-white flex items-center justify-between p-4 border shadow-sm rounded-lg hover:shadow-md transition"
    >

      {/* Left Section */}
      <div className="flex items-center gap-4">
        {/* Product Image */}
        <Link to={`/product/${item.product.id}`}>
          <div className="w-20 h-20 bg-gray-50 border rounded-lg p-2 flex items-center justify-center">
            <img
              src={item.product.image}
              className="max-h-full object-contain"
              alt={item.product.title}
            />
          </div>
        </Link>

        {/* Product Details */}
        <div>
          {/* Title */}
          <p className="font-semibold text-gray-800 text-sm hover:text-blue-600 cursor-pointer line-clamp-2 max-w-[260px]">
            {item.product.title}
          </p>

          {/* Price Row */}
          <div className="flex items-center gap-2 mt-1">
            <p className="text-xl font-bold text-gray-900">
              ₹{item.product.discount_price || item.product.price}
            </p>

            {item.product.discount_price && (
              <>
                <p className="line-through text-gray-500 text-sm">
                  ₹{item.product.price}
                </p>
                <p className="text-green-600 text-sm font-semibold">
                  {Math.round(
                    ((item.product.price -
                      item.product.discount_price) /
                      item.product.price) *
                      100
                  )}
                  % off
                </p>
              </>
            )}
          </div>
        </div>
      </div>

      {/* Remove Button (Bin Icon like Flipkart) */}
      <button
        onClick={() => removeWishlist(item.product.id)}
        className="text-gray-500 hover:text-red-600 transition"
      >
        🗑️
      </button>
    </div>
  ))}
</div>


    </div>
  );
}
